export type CustomClaim = {
  type: string;
  value: string;
};

export const CustomClaimTypes = {
  forCommunity: "for-community",
  scopedRole: "scoped-role"
} as const;
export type CustomClaimTypes =
  (typeof CustomClaimTypes)[keyof typeof CustomClaimTypes];

export const EntraAppRoleGlobalAdministrator = "SparkRoles.Admin";
